import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createCheckoutSession = async ({ productId = "dnots_launch", email = null } = {}) => {
  const origin_url = window.location.origin;
  const { data } = await api.post("/checkout/session", {
    product_id: productId,
    origin_url,
    email,
  });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};

export const submitLead = async (email) => {
  const { data } = await api.post("/leads", { email });
  return data;
};
